module.exports = __webpack_public_path__ + "img/01.4ef991b2.jpg";